import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { SummarySection } from '../styled/SummarySection.styled';
import CommitsCount from './CommitsCount';
import ExperienceTimeCount from './ExperienceTimeCount';
import ProjectsCount from './ProjectsCount';

const Summary = () => {
    return (
        <>
            <SummarySection className='g-2'>
                <Col md={5}>
                    <ProjectsCount />
                </Col>
                <Col md={7}>
                    <CommitsCount />
                </Col>
                <Col md={12}>
                    <ExperienceTimeCount />
                </Col>
            </SummarySection>
        </>
    );
};

export default Summary;